import { render, staticRenderFns } from "./Logo_page.vue?vue&type=template&id=b9be6f42&scoped=true&"
import script from "./Logo_page.vue?vue&type=script&lang=js&"
export * from "./Logo_page.vue?vue&type=script&lang=js&"
import style0 from "./Logo_page.vue?vue&type=style&index=0&id=b9be6f42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9be6f42",
  null
  
)

export default component.exports